import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('comApprRsonPopupStore', Object.keys(getters)),
	...mapState('comApprRsonPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('comApprRsonPopupStore', Object.keys(actions)),
	...mapMutations('comApprRsonPopupStore', Object.keys(mutations))
};
